import React from 'react';
import ReactQuill, { Quill } from 'react-quill';
import { StringMap, Delta, Sources } from 'quill';

import './index.scss';

export interface IQuillProps {
  modulesOverride?: StringMap | undefined;
  value: string | undefined;
  onBlur: () => void;
  onChange?: ((content: string, delta: Delta, source: Sources, editor: any) => void) | undefined;
  readOnly?: boolean;
}

const BixbyQuillWrapper: React.FC<IQuillProps> = props => {
  const { modulesOverride, value, onBlur, onChange, readOnly } = props;
  // register custom fonts
  const font = Quill.import('formats/font');
  font.whitelist = ['Open Sans', 'Roboto'];
  Quill.register(font, true);
  if (modulesOverride) {
    return <ReactQuill modules={modulesOverride} />;
  } else {
    const options = [
      ['bold', 'italic', 'underline', 'strike'],
      [{ list: 'ordered' }, { list: 'bullet' }],
      [{ indent: '-1' }, { indent: '+1' }],
      [{ size: ['small', false, 'large', 'huge'] }],
      [{ font: ['Open Sans', 'Roboto'] }],
      [{ align: '' }, { align: 'center' }, { align: 'right' }, { align: 'justify' }]
    ];
    const modules = { toolbar: options };
    return <ReactQuill value={value} modules={modules} onBlur={onBlur} onChange={onChange} readOnly={readOnly} />;
  }
};

export default BixbyQuillWrapper;
